import React, { FC } from 'react';
import heart from '../../img/heart.png';
import { CurrentWeightInputBlock } from './components/currentWeightInputBlock';
import { GenderButtons } from './components/genderButtons';
import { GoalWeightInputBlock } from './components/goalWeightInputBlock';
import { HeightInputBlock } from './components/heightInputBlock';
import * as S from './styled';

export interface Props {
	gender: string;
	heightUnit: string;
	heightValue: string;
	weightUnit: string;
	currentWeightValue: string;
	goalWeightValue: string;
	onCalculateButtonClick: () => void;
	onChangeGender: (e: string) => void;
	onChangeHeightUnit: (e: string) => void;
	onChangeHeightValue: (e: string) => void;
	onChangeWeightUnit: (e: string) => void;
	onChangeCurrentWeightValue: (e: string) => void;
	onChangeGoalWeightValue: (e: string) => void;
	isInputEmpty: boolean;
}

export const ValuesBlock: FC<Props> = props => {
	const {
		gender,
		heightUnit,
		heightValue,
		weightUnit,
		currentWeightValue,
		goalWeightValue,
		onCalculateButtonClick,
		onChangeGender,
		onChangeHeightUnit,
		onChangeHeightValue,
		onChangeWeightUnit,
		onChangeCurrentWeightValue,
		onChangeGoalWeightValue,
		isInputEmpty,
	} = props;

	return (
		<S.Container>
			<S.Image src={heart} width={165} alt='heart' />
			<S.Title>Your parameters</S.Title>
			<S.Description>
				Knowing your parameters helps us calculate your BMI and personalize our plan for you.
			</S.Description>

			<GenderButtons gender={gender} onChangeGender={onChangeGender} />
			<HeightInputBlock
				heightValue={heightValue}
				heightUnit={heightUnit}
				onChangeHeightUnit={onChangeHeightUnit}
				onChangeHeightValue={onChangeHeightValue}
			/>
			<CurrentWeightInputBlock
				currentWeightValue={currentWeightValue}
				weightUnit={weightUnit}
				onChangeWeightUnit={onChangeWeightUnit}
				onChangeWeightValue={onChangeCurrentWeightValue}
			/>
			<GoalWeightInputBlock
				weightUnit={weightUnit}
				goalWeightValue={goalWeightValue}
				onChangeWeightUnit={onChangeWeightUnit}
				onChangeWeightValue={onChangeGoalWeightValue}
			/>

			<S.Button onClick={() => onCalculateButtonClick()} isInputEmpty={isInputEmpty}>
				Calculate
			</S.Button>
		</S.Container>
	);
};
